module.exports = __webpack_public_path__ + "img/new10.1e514a8a.jpg";